<div class="form-group">

  @if (showLabel && (question?.question_copy || question?.email_version)) {
    <label [innerHtml]="question?.question_copy || question?.email_version" class="form-group__label"></label>
  }


  <!--Using ng-option and for loop-->
  <!-- <ng-select [multiple]="true" >
  <ng-template *ngFor="let option of options; let i = index">
    <input id="item-{{ i }}" type="checkbox" /> {{option.answer}}
  </ng-template>
</ng-select> -->

<div class="ng-select--search-wrap">
  <svg class="icon"><use xlink:href="#search"></use></svg>

  <ng-select [multiple]="true" (close)="submit()" (change)="submit()" [closeOnSelect]="false" [items]="options" bindLabel="answer" bindValue="answer" placeholder="Search and select" [(ngModel)]="selectedItems">

    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" >
      <div class="ng-select-custom-checkbox">
        <input id="item-{{ index }}" type="checkbox"  [ngModel]="item$.selected" [ngModelOptions]="{ standalone: true }"  />
        <label for="item-{{index}}">{{ item.answer }}</label>
      </div>
    </ng-template>

  </ng-select>
</div>

</div>


